import { render, staticRenderFns } from "./OrganizationEmailEdit.vue?vue&type=template&id=6bcb99e6&"
import script from "./OrganizationEmailEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationEmailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports